import React from 'react';
import TextInput from '../../form/TextInput';
import createForm from "./Form";

class RichSnippetForm extends React.Component {

    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-sm-4 col-sm-push-8">
                        <TextInput name={this.props.componentConfig.idfield} value={this.props.values[this.props.componentConfig.idfield]} label="Kód"
                                   role="idfield" {...this.props.getFieldProps(this.props.componentConfig.idfield)}/>
                    </div>
                    <div className="col-sm-8 col-sm-pull-4">
                        <TextInput name="component_type" value={this.props.values.component_type} label="Komponens"
                                   saveChanges={this.props.setFieldValue} {...this.props.getFieldProps("component_type")}/>
                    </div>
                </div>
                <div className="row form-row">
                </div>
            </form>
        );
    }
}

export default createForm(RichSnippetForm);
